import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateTimeManagementDto } from "@myapp/contract";
import { timeEntryApi } from "../service";
import { timeEntryKeys } from "../time-entry.keys";
import { rescheduleKeys } from "src/entities/reschedule";

export function useCreateTimeManagement() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CreateTimeManagementDto) =>
      timeEntryApi.createTimeManagement(dto).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: timeEntryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: rescheduleKeys.count() });

    },
  });
}
